import React, { useState } from "react";
import { Map, Marker, ZoomControl, Overlay } from "pigeon-maps";
import { Link } from "react-router-dom";
import {
  Container,
  Grid,
  IconButton,
  Typography,
  Paper,
  Box,
  SvgIcon,
} from "@mui/material";

const LocationMapPigeon = ({
  places,
  onMarkerClick,
  center,
  createPlaceMode,
  onMapClick,
  height,
  width,
}) => {
  const [activeMarker, setActiveMarker] = useState(null);
  const [activePopup, setActivePopup] = useState(null);

  const handleMapClick = ({ latLng }) => {
    if (createPlaceMode) {
      const newMarker = {
        coordinates: {
          latitude: latLng[0],
          longitude: latLng[1],
        },
      };
      setActiveMarker(newMarker);
      setActivePopup(null);
      if (onMarkerClick) {
        onMarkerClick(newMarker);
      }
      if (onMapClick) {
        onMapClick(newMarker.coordinates);
      }
    } else {
      setActiveMarker(null);
      setActivePopup(null);
    }
  };

  const handleMarkerClick = (place) => {
    setActiveMarker(place);
    if (!createPlaceMode) {
      setActivePopup(place);
      if (onMarkerClick) {
        onMarkerClick(place);
      }
    }
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} md={12} lg={12}>
          <Map
            defaultCenter={[43.204, 27.91]}
            center={center}
            defaultZoom={13}
            onClick={handleMapClick}
            height={height}
            width={width}
          >
            <ZoomControl />

            {places.map((place) => (
              <Marker
                key={place._id}
                anchor={[
                  place.coordinates.latitude,
                  place.coordinates.longitude,
                ]}
                payload={place}
                onClick={() => handleMarkerClick(place)}
                color="red"
                width={40}
                height={40}
              />
            ))}

            {activeMarker && (
              <Marker
                anchor={[
                  activeMarker.coordinates.latitude,
                  activeMarker.coordinates.longitude,
                ]}
                color={createPlaceMode ? "blue" : "red"}
                width={40}
                height={40}
              />
            )}

            {activePopup && !createPlaceMode && (
              <Overlay
                anchor={[
                  activePopup.coordinates.latitude,
                  activePopup.coordinates.longitude,
                ]}
                offset={[-20, 200]}
              >
                <Box
                  sx={{
                    background: "white",
                    p: 0.625, // 5px = 0.625 * 8px
                    borderRadius: "5px",
                    width: "300px",
                    height: "400px",
                    overflow: "auto",
                    sx: {
                      "@media (min-width: 600px)": {
                        width: "300px",
                        height: "400px",
                      },
                      "@media (min-width: 900px)": {
                        width: "300px",
                        height: "400px",
                      },
                    },
                  }}
                >
                  <h3>{activePopup.name}</h3>
                  <img
                    src={
                      activePopup.images && activePopup.images.length > 0
                        ? activePopup.images[0]
                        : ""
                    }
                    alt={`popup-${activePopup._id}`}
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                  <p>{activePopup.description}</p>
                  <Link to={`/places/${activePopup._id}`}>
                    <button>View Place</button>
                  </Link>
                </Box>
              </Overlay>
            )}
          </Map>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LocationMapPigeon;
